import React, { memo } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import * as ProductReturnWindowConfig from '../../ProductReturnWindowConfig';
import { useProductReturnWindows } from '../context';
import { PRODUCT_WINDOW_TYPE } from '../../stubs';
import { ReactComponent as PenIcon } from 'assets/ss-icons/pen.svg';

function Window({ data = {} }) {
  const { onReload } = useProductReturnWindows();

  const id = _get(data, 'id', '');
  const name = _get(data, 'name', '');
  const serviceDays = _get(data, 'service_days', 0);
  const skuCount = _get(data, 'products_count', 0);
  const variantsCount = _get(data, 'product_variants_count', 0);
  const productTypesCount = _get(data, 'product_types_count', 0);

  /** @type {keyof typeof PRODUCT_WINDOW_TYPE} */
  const windowType = _get(data, '_windowType', PRODUCT_WINDOW_TYPE.SKU);

  let subtitle = '';
  if (windowType === 'SKU') {
    subtitle = `${variantsCount} ${
      variantsCount === 1 ? 'variant' : 'variants'
    } selected`;
    if (skuCount > 0) {
      subtitle = `${skuCount} ${skuCount === 1 ? 'SKU' : 'SKUs'}, ${subtitle}`;
    }
  } else {
    subtitle = `${productTypesCount} ${
      productTypesCount === 1 ? 'type' : 'types'
    } selected`;
  }

  return (
    <UiKit.Card>
      <UiKit.Card.Body>
        <UiKit.Flex align="center" justify="space-between" gap={16}>
          <UiKit.Flex direction="column" gap={4}>
            <UiKit.Flex align="center" gap={8}>
              <UiKit.Text weight="bold">
                {name} ({subtitle})
              </UiKit.Text>
              <UiKit.Tag variant="neutral">
                {serviceDays} {serviceDays === 1 ? 'day' : 'days'}
              </UiKit.Tag>
            </UiKit.Flex>
          </UiKit.Flex>
          <UiKit.Flex gap={16}>
            <ProductReturnWindowConfig.Provider
              key={`config-${id}`}
              windowId={id}
              windowType={windowType}
              onSaved={onReload}
            >
              <ProductReturnWindowConfig.Trigger size="sm">
                <PenIcon />
                Edit
              </ProductReturnWindowConfig.Trigger>
              <ProductReturnWindowConfig.Form />
            </ProductReturnWindowConfig.Provider>
          </UiKit.Flex>
        </UiKit.Flex>
      </UiKit.Card.Body>
    </UiKit.Card>
  );
}

export default memo(Window);
